import { useState, useEffect } from 'react';

// Etat reseau courant. Defaut online si navigator absent (SSR/tests).
export function getIsOnline() {
  return typeof navigator === 'undefined' ? true : navigator.onLine;
}

// Hook reactif a navigator.onLine + events online/offline.
export function useOnline() {
  const [online, setOnline] = useState(getIsOnline());

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return online;
}
